export const PRODUCTION_URL = "https://businessplaywright.com/";
export const PRODUCTION_HOST_PATTERN = /(^|\.)businessplaywright\.com$/;
export const CALENDLY_URL = "https://calendly.com/craig-loveyourwork/30min";

const A = "/assets/business-playwright";

export const ASSETS = {
  logo: `${A}/business-playwright-logo.png`,
  productionPhoto: `${A}/while-we-wait-production-photo.webp`,
  takeoverPoster: `${A}/the-takeover-poster.png`,
  blindFaithPoster: `${A}/blind-faith-poster.png`,
  phonePoster: `${A}/how-to-turn-your-phone-off-poster.png`,
  craigPortrait: `${A}/craig-doe-wilmann-portrait.png`,
  craigPortraitWeb: `${A}/web/craig-doe-wilmann-portrait-640.webp`,
  timOliverAction: `${A}/tim-oliver-action.jpg`,
  timOliverPortrait: `${A}/tim-oliver-portrait.jpg`,
  favicon32: `${A}/favicon-32.png`,
  favicon192: `${A}/favicon-192.png`,
  appleTouchIcon: `${A}/apple-touch-icon-180.png`,
};

export const SECTION_IDS = {
  businessStories: "business-stories",
  businessProductions: "productions-for-businesses",
  publicProductions: "productions-for-the-general-public",
  attention: "in-person-storytelling",
  about: "about",
  bookACall: "book-a-call",
};

// href: null until destination URLs are supplied — posters render as non-links.
export const BUSINESS_POSTERS = [
  { id: "the-takeover", src: `${A}/the-takeover-poster.png`, alt: "The Takeover theatre poster", href: "/the-takeover" },
  { id: "how-to-turn-your-phone-off", src: `${A}/how-to-turn-your-phone-off-poster.png`, alt: "How To Turn Your Phone Off theatre poster", href: "/how-to-turn-your-phone-off" },
  { id: "blind-faith", src: `${A}/blind-faith-poster.png`, alt: "Blind Faith theatre poster", href: "/blind-faith" },
];

export const PUBLIC_POSTERS = [
  { id: "while-we-wait", src: `${A}/while-we-wait-poster.png`, action: "ticket-alerts", alt: "While We Wait theatre poster", href: null },
  { id: "liverpool-brain", src: `${A}/liverpool-brain-poster.png`, action: "ticket-alerts", alt: "Liverpool Brain theatre poster", href: null },
  { id: "dont-upset-me", src: `${A}/dont-upset-me-poster.png`, action: "ticket-alerts", alt: "Don’t Upset Me theatre poster", href: null },
];

export const SEO = {
  title: "The Business Playwright | Live Theatre for Business",
  description:
    "The Business Playwright turns business stories into professionally produced stage plays and creates unforgettable live training and team-building experiences.",
  organisationName: "The Business Playwright",
  legalName: "Love Your Work Limited",
};

export const NAV = [
  { label: "PUT YOUR STORY ON STAGE", id: "put-your-story-on-stage", href: "/put-your-story-on-stage" },
  {
    label: "PRODUCTIONS",
    id: "productions",
    items: [
      { label: "For Businesses", target: SECTION_IDS.businessProductions },
      { label: "For the General Public", target: SECTION_IDS.publicProductions },
    ],
  },
  { label: "ABOUT", id: "about", href: "/about" },
];
